<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Add navigation tabs -->
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'user' }"
            @click="activeTab = 'user'">
            Kullanıcı Ayarları
          </a>
        </li>

      </ul>

      <!-- User Edit Form -->
      <div class="row" v-show="activeTab === 'user'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Kullanıcı Düzenle</h4>
              <p class="card-category">Kullanıcıyı düzenleyin.</p>


              <form class="m-5">
                <div class="row">
                  <div class="col-md-8">
                    <base-input type="text" label="Adı" placeholder="Adı" v-model="user.name">
                    </base-input>
                  </div>


                  <div class="col-md-4">
                    <base-input type="text" label="Soyadı" placeholder="Soyadı" v-model="user.surname">
                    </base-input>
                  </div>

                </div>

                <div class="row">
                  <div class="col-md-6">
                    <base-input type="text" disabled label="Email" placeholder="Email" v-model="user.email">
                    </base-input>
                  </div>
                  <div class="col-md-6">
                    <base-input type="text" label="Şifre" placeholder="Şifre" v-model="user.password">
                    </base-input>
                  </div>

                </div>


                <div class="row">

                  <div class="col-md-6">
                    <label>Rol Seçimi</label>

                    <select class="form-control" v-model="user.role">
                      <option value="-1">Rol Seçiniz</option>
                      <option v-for="role in roleMap" :key="role._id" :value="role._id">
                        {{ role.name }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-6" v-if="user.role == 'DEALER_PARTNER'">
                    <label>Bayii Seçimi</label>

                    <div v-for="dealer in user.dealers" :key="dealer" class="mb-3">
                      <select class="form-control" v-model="dealer.dealerId">
                        <option value="-1">Bayii Seçiniz</option>
                        <option v-for="dealer in dealers" :key="dealer._id" :value="dealer._id">
                          {{ dealer.title }} ({{ dealer.code }})
                        </option>
                      </select>
                      <button type="submit" class="btn btn-danger btn-fill float-right btn-sm pt mt-1 mb-4"
                        @click="removeDealer(dealer.dealerId)">
                        Sil
                      </button>
                    </div>
                    <div>
                      <button type="submit" class="btn btn-secondary btn-fill float-right btn-sm pt mt-5"
                        @click="addNewDealer()">
                        Başka Bayii Ekle
                      </button>
                    </div>
                  </div>



                </div>


                <div class="row pt-5">
                  <div class="col-md-12">
                    <label>Aktif Mi?</label>
                    <base-checkbox type="text" label="Aktif" placeholder="Aktif" v-model="user.isActive"
                      :checked="user.isActive" @click="user.isActive = !user.isActive">
                    </base-checkbox>
                  </div>
                </div>




                <div class="text-center pt-5">
                  <button type="submit" class="btn btn-info btn-fill float-right" @click="updateUser()">
                    Güncelle
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>
            </template>
          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      id: null,
      user: {
        name: "",
        surname: "",
        email: "",
        password: "",
        role: "-1",
        dealers: [],
        isActive: true
      },
      roleMap: [
        {
          _id: "MODERATOR",
          name: "Moderator"
        },
        {
          _id: "DEALER_PARTNER",
          name: "Bayii Sahibi"
        },
        {
          _id: "ADMIN",
          name: "Admin"
        }
      ],
      dealers: [],
      activeTab: 'user'
    }
  },
  mounted() {
    this.id = window.location.href.split('/').at(-1);
    this.getUser();
    this.getDealers();
  },
  methods: {
    updateUser() {
      CollectionService.updateCollectionItem('users', this.user._id, this.user).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Kullanıcı Güncellendi")
          this.$router.push(`/admin/users`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    getUser() {
      console.log(this.id)
      CollectionService.getCollectionItemWithId('users', this.id).then((res) => {
        this.user = res.user;
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    getDealers() {


      let q = {};
      let p = {};
      let o = { skip: 0, limit: 1000, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`
      CollectionService.getCollection('dealer', query).then((res) => {
        this.dealers = res.dealers;
      })
    },
    addNewDealer() {
      this.user.dealers.push({
        dealerId: "-1",
      });
    },
    removeDealer(dealerId) {
      this.user.dealers = this.user.dealers.filter(dealer => dealer.dealerId !== dealerId);
    }
  }
}
</script>
<style>
.nav-tabs .nav-link {
  cursor: pointer;
}

.attributes-container {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 15px;
  background-color: #f8f9fa;
}

.attributes-container .form-control-sm {
  width: 45%;
  /* Adjust as needed */
}

.attributes-container .btn-sm {
  padding: 0.25rem 0.5rem;
}
</style>